__turbopack_context__.v({
  "descriptionFade": "HomeDetails-module__kppyfW__descriptionFade",
  "descriptionFadeHidden": "HomeDetails-module__kppyfW__descriptionFadeHidden",
  "descriptionViewport": "HomeDetails-module__kppyfW__descriptionViewport",
  "descriptionViewportExpanded": "HomeDetails-module__kppyfW__descriptionViewportExpanded",
});
